import { render } from "./row-grid.vue?vue&type=template&id=87bf265a"
import script from "./row-grid.vue?vue&type=script&lang=js"
export * from "./row-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__